import React, { useEffect, useState } from 'react'
import HttpClient from '../utils/HttpClient';
import DataTable from 'react-data-table-component';
import { FaUpload } from "react-icons/fa";
import { Modal, ModalHeader, ModalBody, ModalFooter, Input } from 'reactstrap';
import Select from 'react-select';
import toast from 'react-hot-toast';
import { useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment/moment';
import { ImCross } from "react-icons/im";
import csvFile from '../Images/csvFile.png'

const DataUpload = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [allItemsList, setAllItemsList] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [modalOpen, setModalOpen] = useState(false);
    const [dateInput, setDateInput] = useState('');
    const [options, setOptions] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const [fileInput, setFileInput] = useState(null);
    const [filePreview, setFilePreview] = useState(null);
    const [itemId, setItemsId] = useState("")
    const locationState = location?.state;
    const [selectedType, setSelectedType] = useState(null);
    const [selectedCsvType, setSelectedCsvType] = useState(null);
    const typeOptions = [
        { value: "bar", label: "bar" },
        { value: "table", label: "table" }
    ]
    const csvType = [
        { value: "daily", label: "Daily" },
        { value: "weekly", label: "Weekly" },
        { value: "monthly", label: "Monthly" }
    ]

    // >>>>Toggle Modal<<<<
    const toggleModal = (ele) => {
        setModalOpen(!modalOpen);
        setFileInput(null)
        setFilePreview(null)
        setDateInput("")
        if (ele) {
            setItemsId(ele?._id);
        } else {
            setItemsId("");
        }
    };

    // >>>>Handle IMage Changes<<<<
    const handleImageChange = async (e) => {
        let file = e.target.files[0];
        console.log("df52g62", file)
        if (file) {
            setFileInput(file);
            setFilePreview(URL.createObjectURL(file));
        }
    };

    // Handle Remove Image
    const handleRemoveImage = () => {
        setFileInput(null);
        setFilePreview(null);
    };

    // >>>>Handle Select change<<<<
    const handleSelectChange = (selectedOption) => {
        // setSelectedUser(selectedOption);
        setSelectedType(selectedOption);
    };

    // >>>>Handle Select change<<<<
    const handleSelectCsvTypeChange = (selectedOption) => {
        // setSelectedUser(selectedOption);
        console.log("LINE76",selectedOption);
        
        setSelectedCsvType(selectedOption);
    };

    // >>>>Formating the option<<<<
    const formatOptions = (data) => {
        return data?.map(user => ({
            value: user._id,
            label: `${user.firstName} ${user.lastName} (${user?.emailID})`
        }));
    };

    // >>>>Fetch User Data<<<<
    const fetchAllUsers = async () => {
        try {
            const res = await HttpClient.requestData("user-list", "GET");
            if (res && res?.status) {
                // setAllUsersList(res?.data);
                setOptions(formatOptions(res?.data));
            } else {
                toast.error("Failed to fetch user data.");
            }
        } catch (error) {
            toast.error("An error occurred while fetching user data.");
        }
    };

    // >>>>Fetch All Items Data<<<<
    const fetchAllItems = async () => {
        const res = await HttpClient.requestData("project-item", "GET");
        console.log("LINE93", res);

        if (res && res?.status) {
            const arr = res?.data?.map((ele, ind) => ({
                sl: ind + 1,
                itemName: ele?.itemName,
                type: ele?.type,
                status: ele?.status === "Active" ? <p style={{ color: "#33614C", fontWeight: "bold" }}>{ele?.status}</p> : <p style={{ color: "#bda800", fontWeight: "bold" }}>{ele?.status}</p>,
                action: (
                    <span onClick={() => toggleModal(ele)}>
                        <FaUpload style={{ fontSize: "20px", cursor: "pointer", color: "#0077a4" }} />
                    </span>
                )
            }));
            setAllItemsList(arr);
        }
    };

    // >>>>Columns Definition<<<<
    const columns = [
        {
            name: 'SL',
            selector: row => row.sl,
            sortable: true,
            wrap: true
        },
        {
            name: 'Item-Name',
            selector: row => row.itemName,
            sortable: true,
            wrap: true
        },
        {
            name: 'Graph-Type',
            selector: row => row.type,
            sortable: true,
            wrap: true
        },
        {
            name: 'Status',
            selector: row => row.status,
            sortable: true,
            wrap: true
        },
        {
            name: 'Upload-Data',
            selector: row => row.action,
            sortable: true,
            wrap: true,
        },
    ];

    // >>>>Search items by their name<<<<
    const searchUser = allItemsList.filter(data =>
        data?.itemName?.toLowerCase()?.includes(searchQuery.toLowerCase())
    );

    // >>>>Handle Form Submission<<<<
    const handleSubmit = async () => {
        const selectedDate = moment(dateInput, "YYYY-MM-DD", true);
        const today = moment().startOf('day');

        if (!dateInput.trim()) {
            toast.error("Please enter date...!");
            return;
        }
        // if (selectedDate.isBefore(today, 'day')) {
        //     toast.error("Please select valid date...!.");
        //     return;
        // }
        if (!fileInput) {
            toast.error("Please upload file...!");
            return;
        }

        const data = {
            'statisticsDate': selectedDate.format("YYYY-MM-DD"),
            'csvFile': fileInput,
            'projectID': locationState,
            'itemID': itemId,
            ...((itemId === "668e89c8122e2e2ce164d399" ||
                itemId === "66d58ddcb20c2ca1f6be5511" ||
                itemId === "66d58dc6b20c2ca1f6be5509" ||
                itemId === "66d58da2b20c2ca1f6be5501" ||
                itemId === "66d80fcb4648b7038c54cc85" ||
                itemId === "66d80fc54648b7038c54cc7d" ||
                itemId === "66d80fb64648b7038c54cc75"
            ) && { 'wbsType': selectedType?.value }),
            ...((itemId === "668e83e4122e2e2ce164d2e5" ||
                itemId === "668e83cb122e2e2ce164d2d9" ||
                itemId === "668e8347122e2e2ce164d2d1" ||
                itemId === "668e7bbe568ee2fa8024bc3e" ||
                itemId === "668d8a32cd16a938a1dbc981" 
                // || itemId === "668d8a2ccd16a938a1dbc97d"
            ) && { 'csvType': selectedCsvType?.value })

        }

        console.log("LINE205", data)
        // return
        try {
            const res = await HttpClient.requestFormData("projectStatistics", "POST", data);
            if (res && res?.status) {
                toast.success(res?.message || "Data uploaded successfully...!")
                setFileInput(null)
                setFilePreview(null)
                setDateInput("")
                setSelectedUser(null)
                toggleModal();
                // alert(1)
            } else {
                // alert(2)//
                return toast.error(res?.message || "Something went wrong...!")
            }
            console.log(res);
        } catch (error) {
            // alert(3)
            return toast.error('Error submitting form:', error);
        }
    };


    // >>>>Handle Back <<<<
    const handleBackClick = () => {
        navigate(-1);
    };

    useEffect(() => {
        fetchAllItems();
        fetchAllUsers();
    }, [])
    return (
        <div className='manageUsers' style={{ position: 'relative' }}>
            {/* Heading */}
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '20px 0' }}>
                <h3 style={{ fontSize: '20px' }}>Uploaded Items</h3>
                <b className='back' style={{ color: "rgb(212, 52, 52)", cursor: "pointer" }} onClick={handleBackClick}>
                    <i className="fas fa-arrow-left" style={{ marginRight: '8px', }}></i>
                    Back
                </b>
            </div>

            {/* Search Input */}
            <div className="header-container Search_box d-flex justify-content-start p-2">
                <form className="form-inline" style={{ boxShadow: "0 4px 8px rgba(0, 0, 0, 0.5)" }} onSubmit={(e) => e.preventDefault()}>
                    <input
                        className="form-control"
                        type="search"
                        placeholder="Search by item name..."
                        aria-label="Search"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                    />
                    <button className="Search_icon" type="submit">
                        <i className="fa-solid fa-magnifying-glass"></i>
                    </button>
                </form>
            </div>

            {/* DataTable */}
            <div className='mt-2 shadow-lg'>
                <DataTable
                    columns={columns}
                    data={searchUser}
                    pagination={true}
                    responsive={true}
                    highlightOnHover={true}
                />
            </div>


            {/* Upload Modal */}
            <Modal isOpen={modalOpen} toggle={() => setModalOpen(false)} >
                <ModalHeader toggle={toggleModal}>Uploaded Items Data</ModalHeader>
                <ModalBody>
                    {/* CSV Type */}
                    {
                        (itemId === "668e83e4122e2e2ce164d2e5" ||
                            itemId === "668e83cb122e2e2ce164d2d9" ||
                            itemId === "668e8347122e2e2ce164d2d1" ||
                            itemId === "668e7bbe568ee2fa8024bc3e" ||
                            itemId === "668d8a32cd16a938a1dbc981"
                            // || itemId === "668d8a2ccd16a938a1dbc97d"
                        ) &&
                        <div className="mt-2">
                            <label>Type</label>
                            <Select
                                className='w-100'
                                value={selectedCsvType}
                                onChange={handleSelectCsvTypeChange}
                                options={csvType}
                                placeholder="Select type"
                            />
                        </div>
                    }


                    {/* Title */}
                    <div>
                        <label>Date</label>
                        <Input
                            type="date"
                            value={dateInput}
                            onChange={(e) => setDateInput(e.target.value)}
                        />
                    </div>

                    {/* Select Graph */}
                    {
                        (itemId === "668e89c8122e2e2ce164d399" ||
                            itemId === "66d58ddcb20c2ca1f6be5511" ||
                            itemId === "66d58dc6b20c2ca1f6be5509" ||
                            itemId === "66d58da2b20c2ca1f6be5501" ||
                            itemId === "66d80fcb4648b7038c54cc85" ||
                            itemId === "66d80fc54648b7038c54cc7d" ||
                            itemId === "66d80fb64648b7038c54cc75"
                        ) &&
                        <div className="mt-2">
                            <label>Select Type</label>
                            <Select
                                className='w-100'
                                value={selectedType}
                                onChange={handleSelectChange}
                                options={typeOptions}
                                placeholder="Select type"
                            />
                        </div>}

                    {/* Upload File */}
                    <div className="file mt-3" style={{ display: 'flex', flexDirection: "row", gap: "15px" }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <input
                                type="file"
                                id="fileInput"
                                className="fileInput"
                                onChange={handleImageChange}
                                style={{ marginRight: '10px' }}
                            />
                            <label htmlFor="fileInput">Choose File<i className="fas fa-upload"></i></label>
                        </div>
                        <div>
                            {filePreview && (
                                <div style={{ marginLeft: '20px' }}>
                                    <img src={csvFile} alt="Preview" style={{ border: "1px solid #eee", borderRadius: "10px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.5)", width: '100px', height: '100px', objectFit: 'cover' }} />
                                    <ImCross onClick={handleRemoveImage} style={{ marginTop: '-5rem', color: 'red', fontWeight: "bold", cursor: "pointer" }} />
                                </div>
                            )}
                        </div>
                    </div>

                </ModalBody>
                <ModalFooter>
                    <div className='d-flex justify-content-center gap-2 w-100'>
                        <button className="btn btn-outline-success w-50" onClick={handleSubmit}>Submit</button>{' '}
                        <button className="btn btn-outline-secondary w-50" onClick={toggleModal}>Cancel</button>
                    </div>
                </ModalFooter>
            </Modal>

        </div >

    )
}

export default DataUpload